module.exports = __webpack_public_path__ + "couv coco insta.png?ed465d31cf4fbe20bb7756c6fe9e2a49";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/couv coco insta.png
// module id = 128
// module chunks = 0